import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/job/post";

const jobPostApi = {
  jobPosts(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getJobPostUsersManager(params: any): Promise<any> {
    const url = `${path}/managers`;
    return api.get(url, params);
  },

  getJobPostDetail(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postJobPost(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putJobPost(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  updateDisplayStatusJobPost(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}/display-status`;
    return api.put(url, dataForm);
  },

  deleteJobPost(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export const benifitJobPostApi = {
  benifitActive(): Promise<any> {
    const url = `/benefit/active`;
    return api.get(url);
  },
}

export default jobPostApi;
